export default __webpack_public_path__ + "static/media/Linero3Open.ec5d66d2.png";